module.exports = __webpack_public_path__ + "static_pc/img/13.3ec4e769.png";